/* eslint-disable @typescript-eslint/no-non-null-assertion */
import isDesktop from '@lib/is-desktop';

let metaMenuElement: null | HTMLDivElement = null;

export default function getMetaMenu(): HTMLDivElement | null {
    return metaMenuElement;
}

export function initMetaMenu(): HTMLDivElement | null {
    metaMenuElement = document.getElementById('meta-menu') as HTMLDivElement | null;
    if (!metaMenuElement) throw new Error('Could not find element with meta-menu id!');
    const metaMenuParent = metaMenuElement.parentElement!;

    window.addEventListener('resize', () => {
        if (isDesktop()) {
            metaMenuParent?.appendChild(metaMenuElement!);
        }
    });

    return metaMenuElement;
}

window.Drupal.behaviors['metaMenu'] = {
    attach(context: Document | HTMLElement) {
        once('meta-menu', '.meta-menu-navigation', context).forEach((metaMenu) => {
            metaMenu.querySelectorAll('.button').forEach((button) => {
                button.addEventListener('click', (e) => {
                    metaMenu.querySelectorAll('.is-active').forEach((item) => {
                        if (item !== button.parentElement) {
                            item.classList.remove('is-active');
                        }
                    });

                    button.parentElement?.classList.toggle('is-active');
                    e.preventDefault();
                    e.stopPropagation();
                });
            });

            const close = () =>
                metaMenu.querySelectorAll('.is-active').forEach((item) => item.classList.remove('is-active'));

            document.addEventListener(
                'focus',
                (e) => {
                    if (!metaMenu.contains(e.target as Node)) {
                        close();
                    }
                },
                true
            );

            document.addEventListener('click', (e) => {
                if (!metaMenu.contains(e.target as Node)) {
                    close();
                }
            });
        });
    },
};
